import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/builds/r3013/public-website-front/layouts/default.vue").then(m => m.default || m)),
  error: defineAsyncComponent(() => import("/builds/r3013/public-website-front/layouts/error.vue").then(m => m.default || m))
}